import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
} from 'config/providers';
import { OptimumTheme } from 'config/themes';

export const OptimumOffers: SingleProviderConfig = {
  name: 'OptimumOffers',
  micrositeCode: 'Optimum',
  mainProvider: Optimum,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'optimumoffers.com',
  homepage: 'https://optimumoffers.com',
  title: 'Optimum Authorized Dealer',
  fallbackPhoneNumber: '833-678-5587',
  fallbackLeadModePhoneNumber: '833-678-5588',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: OptimumTheme,
  needsDcSession: false,
  source: 'Optimum',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Mediacom,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
  ],
};
